const Contracts = () => import(/* webpackChunkName: "admin-module" */ './Contracts/views/Contracts');
const Profile = () => import(/* webpackChunkName: "admin-module" */ './Profile');
import dashboardRoutes from '@views/Admin/Dashboard/routes';
import bookingRoutes from '@views/Admin/Bookings/routes';
import vehicleRoutes from '@views/Admin/Vehicles/routes';
import clientRoutes from '@views/Admin/Clients/routes';
import contractRoutes from '@views/Admin/Contracts/routes';
import specialOfferRoutes from '@views/Admin/Specialoffers/routes';
import userRoutes from '@views/Admin/Users/routes';
import settingsRoutes from '@views/Admin/Settings/routes';

export default [
    ...dashboardRoutes,
    ...bookingRoutes,
    ...vehicleRoutes,
    ...clientRoutes,
    ...contractRoutes,
    ...specialOfferRoutes,
    ...userRoutes,
    ...settingsRoutes,
    {path: 'profile', name: 'profile', components: { base: Profile }},
];
